export default {"src":"/_next/static/media/icon_compare_pressed.22222f21.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};